import {Component} from "@angular/core";

@Component({
    template: require('./card.transfer.menu.icon.html')
})
export class CardTransferMenuIcon {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/icons/card.transfer.menu.icon.ts